import { render, staticRenderFns } from "./bkPolicyInfo.vue?vue&type=template&id=4c431293&scoped=true"
import script from "./bkPolicyInfo.vue?vue&type=script&lang=js"
export * from "./bkPolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./bkPolicyInfo.vue?vue&type=style&index=0&id=4c431293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c431293",
  null
  
)

export default component.exports